export enum EnumStatusSincronizacaoGeral {
    Erro,
    Vazio,
    Sucesso
}